/*
 *
 * SurveysImport actions
 *
 */

import {
  GET_TEMPLATE_SURVEY_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
  SAVE_TEMPLATE_SUCCESS,
  SAVE_TEMPLATE_PROGRESS,
  SAVE_TEMPLATE_WATCHER,
  GET_SURVEY_SUMMARY_WATCHER,
  GET_SURVEY_SUMMARY_SUCCESS,
  GET_SURVEY_SUMMARY_FAILED,
} from "./constants"

//
// UPLOAD TEMPLATE
export function uploadTemplate(payload) {
  return {
    type: UPLOAD_TEMPLATE_WATCHER,
    payload,
  }
}

export function uploadTemplateSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SUCCESS,
    payload,
  }
}

export function uploadTemplateFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_FAILED,
    payload,
  }
}

// SAVE TEMPLATE SURVEYS
export function saveTemplateSurveyWatcher(payload) {
  return {
    type: SAVE_TEMPLATE_WATCHER,
    payload,
  }
}

export function saveTemplateSuccess(payload) {
  return {
    type: SAVE_TEMPLATE_SUCCESS,
    payload,
  }
}

export function saveTemplateProgress(payload) {
  return {
    type: SAVE_TEMPLATE_PROGRESS,
    payload,
  }
}

// GET TEMPLATE
export function getTemplateSurvey(payload) {
  return {
    type: GET_TEMPLATE_SURVEY_WATCHER,
    payload,
  }
}

export function getTemplateSuccess(payload) {
  return {
    type: GET_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getTemplateFailed() {
  return { type: GET_TEMPLATE_FAILED }
}

// GET TEMPLATE
export function getSurveySummary(payload) {
  return {
    type: GET_SURVEY_SUMMARY_WATCHER,
    payload,
  }
}

export function getSurveySummarySuccess(payload) {
  return {
    type: GET_SURVEY_SUMMARY_SUCCESS,
    payload,
  }
}

export function getSurveySummaryFailed() {
  return { type: GET_SURVEY_SUMMARY_FAILED }
}
